"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apartment_webp_1 = __importDefault(require("../../../../assets/images/apartment.webp"));
const room_webp_1 = __importDefault(require("../../../../assets/images/room.webp"));
const imagesList = [
    {
        position: 1,
        url: room_webp_1.default,
    },
    {
        position: 2,
        url: apartment_webp_1.default,
    },
    {
        position: 3,
        url: room_webp_1.default,
    },
    {
        position: 4,
        url: apartment_webp_1.default,
    },
    {
        position: 5,
        url: room_webp_1.default,
    },
    {
        position: 6,
        url: apartment_webp_1.default,
    },
    {
        position: 7,
        url: room_webp_1.default,
    },
    {
        position: 8,
        url: apartment_webp_1.default,
    },
    {
        position: 9,
        url: room_webp_1.default,
    },
    {
        position: 10,
        url: apartment_webp_1.default,
    },
    {
        position: 11,
        url: room_webp_1.default,
    },
    {
        position: 12,
        url: apartment_webp_1.default,
    },
];
exports.default = imagesList;
